import React from "react";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FONT_SIZE,
  FONT_WEIGHT,
  SPACING,
} from "../../../Constants/Enums/styles.enum";
import { FontFamily } from "../../../Constants/Enums/FontFamily.enums";
import { Colors } from "../../../Constants/colors";
import { WarningIcon } from "../../Icon/WarningIcon";
import { CheckCircleIcon } from "../../Icon/CheckCircleIcon";
import { FontSize } from "../../../Constants/Enums/Size.enums";

export const PendingResultInfo = ({
  totalPendingResults,
}: {
  totalPendingResults: number;
}) => {
  return (
    <>
      {totalPendingResults > 0 && (
        <div
          style={{
            marginTop: SPACING.S10,
            padding: "8px 12px",
            backgroundColor: Colors.LIGHT_TANGERINE_ORANGE,
            border: `1px solid ${Colors.TangerineOrange}`,
            borderRadius: "8px",
            display: DISPLAY.FLEX,
            alignItems: ALIGN_ITEMS.CENTER,
            gap: SPACING.S10,
          }}
        >
          <WarningIcon />
          <div>
            <div
              style={{
                fontFamily: FontFamily.ROBOTO_REGULAR,
                fontSize: FONT_SIZE.F10,
                color: Colors.DarkGrey,
                marginBottom: "1px",
              }}
            >
              Pending Results
            </div>
            <div
              style={{
                fontFamily: FontFamily.ROBOTO_BOLD,
                fontSize: "16px",
                color: Colors.BurgundyRed,
              }}
            >
              {totalPendingResults}
            </div>
          </div>
        </div>
      )}

      {totalPendingResults === 0 && (
        <div
          style={{
            marginTop: "8px",
            padding: "8px 12px",
            backgroundColor: Colors.LIGHT_SUCCESS,
            border: `1px solid ${Colors.Success}`,
            borderRadius: "8px",
            display: DISPLAY.FLEX,
            alignItems: ALIGN_ITEMS.CENTER,
            gap: "8px",
            fontSize: FontSize.F12,
            color: Colors.Success,
            fontFamily: FontFamily.ROBOTO_REGULAR,
            fontWeight: FONT_WEIGHT.MEDIUM,
          }}
        >
          <CheckCircleIcon />
          <span>All results completed</span>
        </div>
      )}
    </>
  );
};
